import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import RightNavbar from "./RightNavbar";
import logo from '../../assets/logo/oakawe.png';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
//   padding: `calc(1em + ${theme.spacing(1)})`,
  paddingTop:'5px',
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderRadius: 0,
  boxShadow:"none !important",
  fontSize:20,
  fontWeight:"bold",
  color: "#004A99",
}));

const Navbar = () => {
  return (
    <Box sx={{ flexGrow: 1 ,height:'74px'}}>
      <Grid sx={{position:'fixed',zIndex:'0'}} container spacing={0}>
        <Grid item xs={2.5}>
          <Item>
            <img src={logo} alt="" />
          </Item>
        </Grid>
        <Grid item xs={9.5}>
          <RightNavbar />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Navbar;
